import { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import styled from 'styled-components';
import { Loading, PrimaryAltButton } from '../atoms';
import { NewUserMerchantModal } from '../molecules';
import { handleOpen, handleClose } from '../../common';
import { MerchantUsersList } from './MerchantUsersList';
import { getMerchantUsers, useUsersStore } from '../../contexts/UsersContext';

const ButtonContainer = styled.div`
  margin-bottom: 2.8125rem;
`;

const AccountContacts = () => {
  const { merchantId: merchantIdFromParams } = useParams();
  const merchantId = merchantIdFromParams || 'unknown';
  const [modalOpen, setModalOpen] = useState(false);
  const clearState = useUsersStore((s) => s.clearState);
  const setMerchantUsers = useUsersStore((s) => s.setMerchantUsers);
  const merchantUsers = useUsersStore((s) => s.merchantUsers);

  const { isLoading, isFetching, refetch } = getMerchantUsers({
    setMerchantUsers,
    query: useQuery,
    merchantId: merchantId
  });

  useEffect(() => {
    return () => clearState();
  }, [clearState]);

  const refreshPage = () => {
    refetch();
  };

  return (
    <>
      <ButtonContainer>
        <PrimaryAltButton
          type="button"
          onClick={() => handleOpen(setModalOpen)}
        >
          Add contact <span className="material-symbols-rounded">add</span>
        </PrimaryAltButton>
        <NewUserMerchantModal
          merchantId={merchantId}
          isModalOpen={modalOpen}
          handleModalClose={() => handleClose(setModalOpen)}
          refreshPage={refreshPage}
        />
      </ButtonContainer>

      {isLoading || isFetching ? (
        <Loading />
      ) : (
        <MerchantUsersList
          merchantUsers={merchantUsers}
          refreshPage={refreshPage}
        />
      )}
    </>
  );
};

export { AccountContacts };
